import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import BgSound from "../../../assets/topstudio/audio/TpbgSound.mp3";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import TpRules from "./pop-up/tp-rules.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Teenpattit20() {
  const dispatch = useDispatch();

  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [pairAVal, setPairAVal] = useState(0);
  const [pairBVal, setPairBVal] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);
  const [isPair1, setIsPair1] = useState(false);
  const [isPair2, setIsPair2] = useState(false);

  const [playerABook, setPlayerABook] = useState(0);
  const [playerBBook, setPlayerBBook] = useState(0);
  const [playerAPlusBook, setPlayerAPlusBook] = useState(0);
  const [playerBPlusBook, setPlayerBPlusBook] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const [stakeLimit, setStakeLimit] = useState(0);

  const sessionUser = useSelector((s) => s.userStore.data);

  const bgAudioRef = useRef(null);

  const [resultData, setResultData] = useState([]);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);
  const timeLeftRef = useRef(TOTAL_SECONDS);
  const timerRoundRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastEvtStatusRef = useRef(null);

  const updateUserData = async (userData) => {
    //await dispatch(setUserData(userData));
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1",
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1"
  });

  const [shownCards2, setShownCards2] = useState({
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "tp20_virtual"
  });

  //console.log("data->", data);

  const displayRunnerName = (runnerName) => {
    if (runnerName === "b1") {
      return "Player A";
    } else if (runnerName === "b2") {
      return "Player B";
    } else if (runnerName === "pairA") {
      return "Player A+";
    } else if (runnerName === "pairB") {
      return "Player B+";
    }
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const payload = data?.data?.data;
  const payloadResult = data?.data?.result;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const [displayLoader, setDisplayLoader] = useState(true);
  //console.log("payload->", payload);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setWinnerA(false);
      setWinnerB(false);
      setIsPair1(false);
      setIsPair2(false);
      setPlayerABook(0);
      setPlayerBBook(0);
      setPlayerAPlusBook(0);
      setPlayerBPlusBook(0);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const leftTime = Number(payload?.left_time);
    if (Number.isNaN(leftTime)) return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setPairAVal(payload?.pairA);
    setPairBVal(payload?.pairB);
    setRoundId(payload?.cat_mid);

    // The socket sends left_time every few seconds, so copying it each time skips numbers.
    // Count down locally, and take the server value only when a new round opens.
    const serverSeconds = Math.max(0, leftTime);
    const roundChanged = timerRoundRef.current !== payload?.cat_mid;
    if (payload?.evt_status !== "OPEN") {
      timeLeftRef.current = 0;
      setTimeLeft(0);
    } else if (roundChanged) {
      timerRoundRef.current = payload?.cat_mid;
      timeLeftRef.current = serverSeconds;
      setTimeLeft(serverSeconds);
    }

    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
    }

    if (payload?.isPair1 == 1) {
      setIsPair1(true);
    }
    if (payload?.isPair2 == 1) {
      setIsPair2(true);
    }
  }, [payload]);

  useEffect(() => {
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev > 0 ? prev - 1 : 0;
        timeLeftRef.current = next;
        return next;
      });
    }, 1000);
    return () => clearInterval(localTimerRef.current);
  }, []);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "tp20_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];

        if (obj.Type === "main") {
          setPlayerABook(obj.PlayerA);
          setPlayerBBook(obj.PlayerB);
        }

        if (obj.Type === "pairA") {
          setPlayerAPlusBook(obj.PlayerAPlus);
        }
        if (obj.Type === "pairB") {
          setPlayerBPlusBook(obj.PlayerBPlus);
        }
      }
    }
  }

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;

    clearTimeout(flipTimerRef.current);
    setFlipStep(0);

    let step = 0;

    /*
    function run() {
      
      if (step >= sequence.length) return;

      const { key, value } = sequence[step];

      // start flip
      setFlipStep(step + 1);

      // swap card exactly at mid-flip
      setTimeout(() => {
        setShownCards((prev) => ({
          ...prev,
          [key]: value && value !== "1" ? value : "1",
        }));
      }, 300); // half of 600ms animation

      step++;
      flipTimerRef.current = setTimeout(run, 600);
    }*/

    function run() {
      // Steps 1–3 → Player A cards
      if (step >= 1 && step <= 3) {
        const key = `ac${step}`;

        setShownCards1((prev) => ({
          ...prev,
          [key]: payload?.[key]
        }));
      }

      // Steps 4–6 → Player B cards
      if (step >= 4 && step <= 6) {
        const cardIndex = step - 3; // 4→1, 5→2, 6→3
        const key = `bc${cardIndex}`;

        setShownCards2((prev) => ({
          ...prev,
          [key]: payload?.[key]
        }));
      }

      //setFlipStep((prev) => prev + 1);
      setFlipStep(step + 1);
      step++;

      if (step <= 6) {
        flipTimerRef.current = setTimeout(run, 1000);
      }
    }

    //checking here for first time

    flipTimerRef.current = setTimeout(run, 1500);

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "card2020_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };
  const [profileData, setProfileData] = useState(null);

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const playBGSoundWithRetry = () => {
    const audio = bgAudioRef.current;
    if (!audio) return;
    audio.play().catch(() => {
      setTimeout(() => audio.play().catch(() => { }), 250);
    });
  };

  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      playBGSoundWithRetry();
    } else {
      bgAudioRef.current?.pause();
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "card2020_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const getCardImage = (cardValue, reveal) => {
    return reveal && cardValue && cardValue !== "1" ? cardValue : "1";
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "tp20_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <>
      {shownCards && (
        <div className="teenpatti-scope aviator-scope player-scope aviator-bg-black">
          <ClientLayoutWithOutHeader showLoader={false}>
            <div class="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                        <TpStudioLoader displayLoader={displayLoader} />
                      </div>

                      <div
                        className="row"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="col-md-8 Exgamesbg">
                          <div className="left-content">
                            <div>
                              <div>
                                <div
                                  className="col-12 timerDiv2"
                                  style={{ marginBottom: "-24px" }}
                                >
                                  <div
                                    className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                    style={{ height: "45px" }}
                                  >
                                    <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                      <p style={{ fontSize: "17px" }}>
                                        TEENPATTI T20
                                      </p>
                                    </div>
                                    <div
                                      className="col-6 col-md-6 inline-block Gameidcol text-right"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <div
                                        role="group"
                                        aria-label="Second group"
                                        className="btn-group btn-group-sm mr-2"
                                      >
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="Alltab"
                                          className={
                                            activeTabIndex == 1
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(1)}
                                        >
                                          Game
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="RESULTStab"
                                          className={
                                            activeTabIndex == 2
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(2)}
                                        >
                                          Results
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          className="tablink btn btn-primary"
                                          onClick={() => setShowRules(true)}
                                        >
                                          Rules
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="row mt-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <div className="col-2 col-md-1">
                                      <div className="Connectedclients mt-1">
                                        <i
                                          aria-hidden="true"
                                          className="fa fa-user mr-1"
                                          style={{
                                            fontSize: "14px",
                                            color: "white"
                                          }}
                                        />
                                        <b>
                                          <span
                                            id="UsersCount"
                                            className="number"
                                          >
                                            326
                                          </span>
                                        </b>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8" />
                                  <div
                                    className="col-md-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    {/* Timer with animated stroke + numeric countdown */}
                                    <div className="teenpatti-base-timer">
                                      <svg
                                        viewBox="0 0 100 100"
                                        className="base-timer__svg"
                                      >
                                        <g className="base-timer__circle">
                                          <circle
                                            cx="50"
                                            cy="50"
                                            r="45"
                                            className="base-timer__path-elapsed"
                                          />
                                          <path
                                            strokeDasharray={`${Math.round(
                                              dash
                                            )} ${Math.round(CIRC)}`}
                                            className={`base-timer__path-remaining ${timerColor}`}
                                            d="
                                                    M 50, 50
                                                    m -45, 0
                                                    a 45,45 0 1,0 90,0
                                                    a 45,45 0 1,0 -90,0
                                                  "
                                          />
                                        </g>
                                      </svg>
                                      <span className="base-timer__label">
                                        {timeLeft}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div
                                  className="cards-layout blackjack"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none",
                                    position: "relative"
                                  }}
                                >
                                  <audio ref={bgAudioRef} src={BgSound} loop />

                                  {/* Players */}
                                  <div
                                    className="table-player"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    {/* PLAYER A */}
                                    <div className="tp20-player">
                                      <span className="name">Player A</span>
                                      <div className="tp-hand">
                                        {/* Card 1 */}
                                        <div
                                          className={`tp-card ${flipStep === 1 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 1 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.ac1 &&
                                            payload?.ac1 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.ac1}.svg`}
                                                draggable={false}
                                                alt=""
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>

                                        {/* Card 2 */}
                                        <div
                                          className={`tp-card ${flipStep === 3 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 3 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.ac2 &&
                                            payload?.ac2 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.ac2}.svg`}
                                                draggable={false}
                                                alt=""
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>

                                        {/* Card 3 */}
                                        <div
                                          className={`tp-card ${flipStep === 5 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 5 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.ac3 &&
                                            payload?.ac3 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.ac3}.svg`}
                                                draggable={false}
                                                alt=""
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>
                                      </div>
                                      {/*<div className="tp-hand">
                                      {payload?.evt_status}
                                      {shownCards1 &&
                                        Object.keys(shownCards1).map(
                                          (key, i) => {
                                            const shouldFlip =
                                              flipStep === i * 2 + 1;
                                            return (
                                              <div
                                                key={key}
                                                className={`tp-card ${
                                                  shouldFlip &&
                                                  payload.evt_status == "CLOSED"
                                                    ? "flip"
                                                    : ""
                                                }`}
                                              >
                                                <img
                                                  src={`/assets/images/cards/${shownCards1[key]}.png`}
                                                  draggable={false}
                                                  alt=""
                                                />
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>*/}
                                    </div>
                                    {/* PLAYER B */}
                                    <div className="tp20-player">
                                      <span className="name">Player B</span>
                                      <div className="tp-hand">
                                        {/* Card 1 */}
                                        <div
                                          className={`tp-card ${flipStep === 2 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 2 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.bc1 &&
                                            payload?.bc1 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.bc1}.svg`}
                                                draggable={false}
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>

                                        {/* Card 2 */}
                                        <div
                                          className={`tp-card ${flipStep === 4 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 4 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.bc2 &&
                                            payload?.bc2 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.bc2}.svg`}
                                                draggable={false}
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>

                                        {/* Card 3 */}
                                        <div
                                          className={`tp-card ${flipStep === 6 &&
                                            payload?.evt_status === "CLOSED"
                                            ? "flip"
                                            : ""
                                            }`}
                                        >
                                          {flipStep >= 6 &&
                                            payload?.evt_status === "CLOSED" &&
                                            payload?.bc3 &&
                                            payload?.bc3 !== "1" && (
                                              <img
                                                src={`/assets/galaxy/img/cards3/${payload?.bc3}.svg`}
                                                draggable={false}
                                                style={{
                                                  width: isMobile
                                                    ? "46px"
                                                    : "70px",
                                                  height: isMobile
                                                    ? "55px"
                                                    : "85px"
                                                }}
                                              />
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* Controls removed (auto mode) */}
                                </div>
                              </div>
                            </div>

                            <div
                              className="tp20-sound-wrap"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <label
                                htmlFor="Tp20Soundcontrol"
                                className={`fa fa-inverse sound-icon ${soundEnabled
                                  ? "fa-volume-up"
                                  : "fa-volume-off"
                                  }`}
                                title="Toggle sound"
                              >
                                <input
                                  id="Tp20Soundcontrol"
                                  type="checkbox"
                                  checked={soundEnabled}
                                  onChange={toggleSound}
                                  style={{ display: "none" }}
                                />
                              </label>
                            </div>

                            {/* Footer */}
                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                style={{ marginTop: "10px" }}
                              >
                                <div className="buttons-div">
                                  {Object.keys(resultList).map((idx) => (
                                    <button
                                      key={idx}
                                      className="video-button border-gradient-btn border-gradient-purple-btn"
                                    >
                                      {resultList[idx] == 1 ? "A" : "B"}
                                    </button>
                                  ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId}</div>
                                </div>
                              </div>
                            </center>

                            {/* Market Sections (unchanged) */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="tb-content"
                                style={{ background: "#fff" }}
                              >
                                <div className="market-titlebar">
                                  <p className="market-name">
                                    <span className="market-name-badge">
                                      <i className="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MAIN </span>
                                      {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                    </span>
                                  </p>
                                  <div className="market-overarround">
                                    <span />
                                    <strong>Back</strong>
                                  </div>
                                  <div className="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>
                                <div className="market-runners">
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerA && flipStep >= 7
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b1Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Player A
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerABook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerABook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerABook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        data-teamname="Player A"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "player a",
                                            "player a",
                                            b1Val
                                          )
                                        }
                                      >
                                        {b1Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerB && flipStep >= 7
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b2Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Player B
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus2"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerBBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerBBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerBBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Player B"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "player b",
                                            "player b",
                                            b2Val
                                          )
                                        }
                                      >
                                        {b2Val}
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style={{ height: "5px" }}></div>
                            {/*- plus -*/}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>Plus </span>
                                  </span>
                                </p>

                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div
                                  className="runner-runner"
                                  style={{ height: "auto" }}
                                >
                                  <h3
                                    className={
                                      isPair1 && flipStep >= 7
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Player A+
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus3"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      playerAPlusBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      playerAPlusBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    playerAPlusBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Player A"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "player a plus",
                                          "player a plus",
                                          pairAVal
                                        )
                                      }
                                    >
                                      {pairAVal}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div
                                  className="runner-runner"
                                  style={{ height: "auto" }}
                                >
                                  <h3
                                    className={
                                      isPair2 && flipStep >= 7
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Player B+
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus4"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      playerBPlusBook != 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      playerBPlusBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    playerBPlusBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Player B Plus"
                                      data-bettype="player b plus"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "player b plus",
                                          "player b plus",
                                          pairBVal
                                        )
                                      }
                                    >
                                      {pairBVal}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              {/*- plus -*/}
                            </div>
                          </div>

                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none",
                              color: "white"
                            }}
                          >
                            <Teenpattit20Result resultData={resultData} />
                          </div>
                        </div>

                        <div className="col-md-4">
                          {showBetSlipPopup && (
                            <TPPopUpBetSlip
                              closeBetSlipParent={closeBetSlipMobile}
                              betObj={placeBetObject}
                              placeBetParent={placeBet}
                              betButtonShow={betButtonShow}
                              betErrorMessageObj={betErrorMessageObj}
                              betButtonShowLoaderShow={betButtonShowLoaderShow}
                              profileData={profileData}
                            />
                          )}

                          <TeenPattisCasinoBetslipWeb
                            showBetSlip={showBetSlip}
                            placeBetObject={placeBetObject}
                            closeBetSlipParent={closeBetSlip}
                            placeBetParent={placeBet}
                            betErrorMessageObj={betErrorMessageObj}
                            profileData={profileData}
                          ></TeenPattisCasinoBetslipWeb>
                          <div>
                            <div className="bets">
                              <strong style={{ fontSize: "16px" }}>
                                Matched Bets (0)
                                <img
                                  src={reconnecting}
                                  alt="dc"
                                  className="rounded disconnected"
                                  style={{ display: "none" }}
                                />{" "}
                              </strong>
                              <div className="betting-table">
                                <table className="table">
                                  <thead>
                                    <tr style={{ fontSize: "16px" }}>
                                      <th>Runner</th>
                                      <th>Price</th>
                                      <th>Size</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {placedBets.map((bet, index) => {
                                      console.log("MATCHED BET:", bet);

                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            background:
                                              bet.type == "b"
                                                ? "#e9f6fc"
                                                : "#fce3e4"
                                          }}
                                        >
                                          <td>
                                            {displayRunnerName(bet.rnr)} - ({bet.cat_mid})
                                          </td>
                                          <td>{bet.amnt}</td>
                                          <td>{bet.rate}</td>
                                          <td></td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <TpRules show={showRules} onClose={() => setShowRules(false)} />
          </ClientLayoutWithOutHeader>

          <style>
            {`
#ExgamesDiv > .col-md-8.Exgamesbg {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }
.teenpatti-scope .tb-content{
  padding-top:3px;
}

.teenpatti-scope .cards-layout.blackjack {
  position: relative;
  background: #000000;
}

.teenpatti-scope .cards-layout.blackjack::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: radial-gradient(
    ellipse 100% 44% at 50% 30%,
    rgba(62, 193, 65, 0.95) 0%,
    rgba(62, 193, 65, 0.8) 15%,
    rgba(30, 80, 35, 0.5) 40%,
    #1e1e1e 55%,
    #1e1e1e 100%
  );
  opacity: 0.4;
  pointer-events: none;
  z-index: 0;
}

.teenpatti-scope .cards-layout.blackjack > * {
  position: relative;
  z-index: 1;
}

.teenpatti-scope .timerDiv2 .col-md-2 {
  position: relative;
  top: -15px;
  right: -12px;
}

.teenpatti-scope .table-player {
  gap: 10px !important;
  justify-content: center;
  align-items: flex-start;
}

.teenpatti-scope .tp20-player {
  width: auto !important;
  max-width: calc(50% - 5px);
  flex: 0 0 auto;
  min-width: 0;
}

.teenpatti-scope .tp-hand {
  width: 220px !important;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.teenpatti-scope .timerDiv2 > .footer-divbpg {
  margin-top: 2px;
}

.teenpatti-scope center > .footer-divbpg {
  position: relative;
  z-index: 2;
  margin-top: 10px;
  background: linear-gradient(180deg, #464646, #0f0f0f);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 45px;
  border: 2px solid;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(
    180deg,
    rgba(207, 141, 46, 0.47),
    #cf8d2e 50%,
    rgba(207, 141, 46, 0.47)
  );
  box-sizing: border-box;
}

.teenpatti-scope center {
  display: block;
  width: 100%;
}

.teenpatti-scope center > .footer-divbpg .buttons-div {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  overflow-x: auto;
}

.teenpatti-scope center > .footer-divbpg .video-button {
  padding: 0;
  background-color: #4f4f4f !important;
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 500;
  height: 35px !important;
  min-width: 35px !important;
  width: auto !important;
  margin-right: 3px;
  text-align: center;
  border: none;
  border-bottom: 1px solid #1a1a1a !important;
  border-right: 1px solid #1a1a1a !important;
  border-radius: 0 !important;
  flex-shrink: 0;
  pointer-events: none;
}

.teenpatti-scope center > .footer-divbpg .round-div {
  margin-right: 4px;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  justify-content: center;
  white-space: nowrap;
  flex-shrink: 0;
}

.teenpatti-scope center > .footer-divbpg .round-div .label {
  color: rgba(255, 255, 255, 0.85);
}

.teenpatti-scope .tp20-sound-wrap {
  position: relative;
  height: 0;
  margin-top: -40px;
  z-index: 4;
}

.teenpatti-scope .tp20-sound-wrap .sound-icon {
  position: absolute;
  right: 18px;
  top: -18px;
  cursor: pointer;
  color: #fff;
  z-index: 4;
  width: 15px;
  height: 15px;
  font-size: 15px;
  line-height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---------------- DESKTOP ---------------- */

@media (min-width:992px){

  .teenpatti-scope .table-player{
    font-size:60px !important;
  }

  .teenpatti-scope .table-player .player-name{
    font-size:13px;
  }

  .teenpatti-scope .market-titlebar .market-name-badge span,
  .teenpatti-scope .market-titlebar .market-overarround strong,
  .teenpatti-scope .market-titlebar .market-overarround-lay strong{
    font-size:14px;
  }

  .teenpatti-scope .row{
    margin-left:0 !important;
    margin-right:0 !important;
  }

  .teenpatti-scope .col-md-8{
    padding-left:19px !important;
    margin-bottom:9px;
  }

  .teenpatti-scope .left-content{
    padding-right:6px;
  }
      .teenpatti-scope .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }

  .teenpatti-scope .left-content .market-titlebar {
    width: 100%;
    display: flex;
    height: 20px;
}

.teenpatti-scope .runner-runner .lobby-btn {
   height: 38px !important;
   min-height: 38px !important;
   padding: 2px 4px !important;
}

.teenpatti-scope .cards-layout.blackjack {
   min-height: 210px;
}
.teenpatti-scope .volume-wrapper {
   margin-top: -35px;
}
  

}

/* ---------------- MOBILE---------------- */

@media (max-width:991px){

  .teenpatti-scope .table-player{
    font-size:16px !important;
  }

  .teenpatti-scope .market-titlebar strong{
    font-size:13px;
  }

  .teenpatti-scope .col-md-8{
    padding-left:15px !important;
  }

  .teenpatti-scope .left-content{
    padding-right:0;
  }

}
 @media (max-width:576px){
 .row {
    margin-right: -20px;
    margin-left: -20px;
  }
  .teenpatti-scope .footer-divbpg{
    display:flex;
    align-items:center;
    justify-content:space-between;
    flex-wrap:nowrap; 
    border-radius:8px;
  }
  .player-scope .tp-card {
    position: absolute;
    top: 10px;
  }
  .teenpatti-scope .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }
  .teenpatti-scope .titlebarname p{
    font-size:18px !important;
  }
  .teenpatti-scope .table-player {
    justify-content: center; 
    gap: 10px !important;  
    padding: 0 24px !important;         
   }
  .teenpatti-scope .btn-group-sm .btn{
    padding:2px 6px;
    font-size:12px;
  }
  .teenpatti-scope .btn-group{
    flex-wrap:nowrap !important;
  }
    .teenpatti-scope .footer-divbpg .btn-group-sm .btn{
    padding:6px 4px !important;
    font-size:12px !important;
    line-height:1.2;
    margin-top: 0;
  }
  .teenpatti-scope .footer-divbpg .titlebarname{
    flex:1;         
    max-width:none !important;
    padding-left:4px;
  }
  .teenpatti-scope .titlebarname p{
    font-size:17px !important;
    margin:0;
    margin-bottom: 12px;
    margin-left: 18px;
  }
    .teenpatti-scope .table-player{
    justify-content:space-between;
    gap:10px;
    padding:0 10px;
  }
  .teenpatti-scope .tp20-player{
    width: auto !important;
    max-width: calc(50% - 5px);
  }
  .teenpatti-scope .tp-hand{
    width: min(180px, calc(50vw - 28px)) !important;
    max-width: 100%;
    height: 83px;
  }
  @scope (.teenpatti-scope) {
    center > .footer-divbpg .video-button {
      padding: 0;
      background-color: #4f4f4f !important;
      color: #fff !important;
      font-size: 12px !important;
      font-weight: 500;
      height: 35px !important;
      min-width: 35px !important;
      width: auto !important;
      margin-right: 3px;
      text-align: center;
      border-radius: 0 !important;
      border-bottom: 1px solid #1a1a1a !important;
      border-right: 1px solid #1a1a1a !important;
    }
  }
}
  @media (max-width: 768px) {

   .teenpatti-scope .cards-layout.blackjack {
      min-height: 175px !important;
   }

   .teenpatti-scope .timerDiv2 {
      margin-bottom: 0 !important;
   }

   .teenpatti-scope .timerDiv2 .col-md-2 {
      top: -6px;
   }

   .teenpatti-scope .timerDiv2 .footer-divbpg {
      margin-top: 0 !important;
   }

   .teenpatti-scope .table-player {
      margin-bottom: 20px;
   }

   .teenpatti-scope .volume-wrapper {
      margin-top: 0 !important;
   }
}
  
`}
          </style>
        </div>
      )}
    </>
  );
}
